import React, { useEffect, useRef, useState } from 'react';
import { WidgetProps } from './WidgetProps';
import { CircularProgress } from '@material-ui/core';
import CodeIcon from '@material-ui/icons/Code';
import { iOS, isSafari } from '../../sidebar/tabsContent/editTab/allLayersSetting/widgetList/utils';

type GenerateIframeStyleProps = {
	isShowWidget?: boolean;
};
const generateIframeStyle = ({ isShowWidget }: GenerateIframeStyleProps) => {
	return {
		opacity: isShowWidget ? 1 : 0,
		width: '100%',
		height: '100%',
	};
};

const IframeWidget = ({
	id,
	isShowWidget,
	itemRef,
	onClickItem,
	widgetTemplateId,
	settings: { url },
	onContextMenu,
}: WidgetProps.BaseProps) => {
	const [urlToRender, setUrlToRender] = useState<string | undefined>('qbrick.com');
	const [isLoading, setIsLoading] = useState(true);
	const iframeRef = useRef<HTMLIFrameElement>(null);
	const debounceTimer = useRef<any>(null);

	let processingUrl = url || 'qbrick.com';
	const isValidUrl = processingUrl.match('^(http|https)://');
	if (isValidUrl?.[0] !== 'http://' && isValidUrl?.[0] !== 'https://') {
		processingUrl = `https://${processingUrl}`;
	}

	const debouncedUpdating = (func: any, timeout = 500) => {
		clearTimeout(debounceTimer.current);
		debounceTimer.current = setTimeout(func, timeout);
	};

	useEffect(() => {
		debouncedUpdating(() => {
			setUrlToRender(processingUrl);
			setIsLoading(true);
		});
	}, [processingUrl]);

	return (
		<g
			id={widgetTemplateId}
			className={`${!isSafari ? 'widget' : ''} widget_${widgetTemplateId}`}
			style={{ pointerEvents: isShowWidget ? 'auto' : 'none' }}
		>
			<g
				ref={itemRef}
				data-template-id={widgetTemplateId}
				data-widget-id={id}
				onClick={(e) => {
					e.stopPropagation();
					isShowWidget && onClickItem?.(itemRef);
				}}
				onContextMenu={(e) => {
					e.preventDefault();
					onContextMenu?.(itemRef, !!isShowWidget);
					return false;
				}}
			>
				{iOS || isSafari ? (
					<foreignObject>
						<div
							className="iframe-widget"
							style={{
								...generateIframeStyle({ isShowWidget }),
								backgroundColor: '#126cfc',
								color: '#ffffff',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								alignItems: 'center',
								fontSize: '20px',
							}}
						>
							<CodeIcon style={{ fontSize: 50, color: '#ffffff86' }} />
							{processingUrl}
						</div>
					</foreignObject>
				) : (
					<foreignObject>
						{isLoading && (
							<div
								style={{
									position: 'absolute',
									width: '100%',
									height: '100%',
									backgroundColor: '#000000',
									opacity: isShowWidget ? 0.5 : 0,
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								<CircularProgress size={40} style={{ opacity: 1, color: '#ffffff' }} />
							</div>
						)}

						<iframe
							ref={iframeRef}
							src={urlToRender ?? ''}
							className="widget iframe-widget"
							style={{
								...generateIframeStyle({ isShowWidget }),
								pointerEvents: 'none',
							}}
							onLoad={() => {
								if (!iframeRef.current) {
									return;
								}
								setIsLoading(false);
							}}
						/>
					</foreignObject>
				)}
			</g>
		</g>
	);
};

export default IframeWidget;
